import { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LEARN_SECTIONS } from '../../../constants/learn';
import LibrarySection from './LibrarySection';

function VideoLibrary() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <Box maxWidth="1180px">
      <Typography variant="h1" component="h1" mb={1}>
        Learn
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        maxWidth="620px"
        mb={3.5}>
        Short videos on running your shop in Porter. Your setup guide is still
        the fastest way through.
      </Typography>

      <Stack gap={2}>
        {LEARN_SECTIONS.filter(section => section.lessons.length > 0).map(
          (section, index) => (
            <LibrarySection
              key={section.title}
              section={section}
              isOpen={index === openIndex}
              onOpen={() => setOpenIndex(index)}
            />
          ),
        )}
      </Stack>
    </Box>
  );
}

export default VideoLibrary;
